<template>
    <!-- Notifications Dropdown Menu -->
    <li class="nav-item dropdown">
        <b-button v-b-modal.notificationsModal class="nav-link"
                  aria-describedby="buttonDescr" variant="outline"
                  :title="$tc('menu.notifications.new_notifications', notifications.length, {count: notifications.length})">
            <b-icon-bell aria-hidden="true"/>
            <span class="sr-only" id="buttonDescr">
                {{ $t('menu.notifications.sr_only.button_text') }}
            </span>
            <span v-if="notificationsAvailable">{{ notifications.length }}</span>
        </b-button>

        <b-modal :title="$t('menu.notifications.title')" title-tag="h3" scrollable id="notificationsModal">
            <b-list-group v-if="notificationsAvailable">
                <b-list-group-item v-for="(notification, index) in notifications" :key="index" tabindex="0">
                    <div class="d-flex w-100 justify-content-between">
                        <h3 class="mb-1" v-if="notification.title">{{ notification.title }}</h3>
                        <small v-if="notification.datetime">{{ notification.datetime }}</small>
                        <small v-if="!notification.datetime && notification.timestamp">{{ notification.timestamp }}</small>
                    </div>

                    <p class="mb-1">
                        {{ notification.simpleMessage }}
                    </p>

                    <b-button class="float-right" size="sm"
                              @click="dropNotification(index)"
                              :title="$t('menu.notifications.clear_one')">
                        <b-icon-trash aria-hidden="true"/>
                    </b-button>
                </b-list-group-item>
            </b-list-group>
            <div v-else>
                {{ $t('menu.notifications.none') }}
            </div>
            <template #modal-footer>
                <b-button @click="dropAll" variant="danger" :disabled="!notificationsAvailable">
                    <b-icon-trash aria-hidden="true"/>
                    {{ $t('menu.notifications.clear_all') }}
                </b-button>
            </template>
        </b-modal>
    </li>
</template>

<script>
export default {
    props: {
        account: String
    },
    data: function () {
        return {
            showModal: false,
            localStorageKey: `bologna_notifications_${this.account}`,
            notifications: localStorage.getItem(`bologna_notifications_${this.account}`) === null
                ? []
                : JSON.parse(localStorage.getItem(`bologna_notifications_${this.account}`))
        };
    },
    mounted() {
        this.$Echo.private(`rz-account.${this.account}`)
            .listen('BolognaEvent', (e) => {
                e.message = this.$purify.sanitize(e.message);
                e.simpleMessage = this.$purify.sanitize(e.simpleMessage);

                this.notifications.unshift(e);
                console.log(e);
                localStorage.setItem(this.localStorageKey, JSON.stringify(this.notifications));
                this.$Bologna.broadcastPaste(e, '.broadcasts-private');
            });
    },
    computed: {
        notificationsAvailable: function () {
            return this.notifications.length > 0;
        }
    },
    methods: {
        dropNotification: function (index) {
            this.notifications.splice(index, 1);
            localStorage.setItem(this.localStorageKey, JSON.stringify(this.notifications));
        },
        dropAll: function () {
            this.notifications = [];
            localStorage.setItem(this.localStorageKey, JSON.stringify(this.notifications));
        }
    }
}
</script>
